module.exports = __webpack_public_path__ + "img/postproduction.04c5adfb.png";